"use strict";
import { addMultipleListeners } from "./helpers";
import Collapse from 'bootstrap/js/dist/collapse';
import Tab from 'bootstrap/js/dist/tab';
document.addEventListener('DOMContentLoaded', () => {
    const collapseElementList = document.querySelectorAll('.collapse');
    const collapseList = [...collapseElementList].map(collapseEl => new Collapse(collapseEl, { toggle: false }));
    const tabElementList = document.querySelectorAll('[data-bs-toggle="tab"]');
    const tabList = [...tabElementList].map(tabEl => new Tab(tabEl));
    function unifiedToggle(triggerIds, bodyClass, overlayId, overlayClass) {
        triggerIds.forEach(triggerId => {
            const trigger = document.getElementById(triggerId);
            if (trigger) {
                addMultipleListeners(trigger, ['click', 'touch'], () => {
                    const newState = document.body.classList.toggle(bodyClass);
                    if (overlayId && overlayClass) {
                        const overlay = document.getElementById(overlayId);
                        overlay === null || overlay === void 0 ? void 0 : overlay.classList.toggle(overlayClass, newState);
                    }
                });
            }
        });
    }
    // Menu toggle
    unifiedToggle(['fn_menu-btn', 'fn_menu-close', 'fn_overlay'], 'menu-open', 'fn_overlay', 'p_overlay--active');
    // Search toggle
    unifiedToggle(['fn_open-search', 'fn_search-close'], 'search-open');
    // Sorting toggle
    unifiedToggle(['fn_open-sorting', 'fn_sorting-close'], 'sorting-open');
    // Escape key press
    document.body.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            document.body.classList.toggle('menu-open', false);
            const overlay = document.getElementById('fn_overlay');
            overlay === null || overlay === void 0 ? void 0 : overlay.classList.toggle('p_overlay--active', false);
        }
    });
    // Show / hide text - categories
    const cover = document.getElementById('fn_catContent');
    if (cover) {
        const hideContent = cover.querySelector('.fn_no-text'), btnTxt = document.querySelector('.fn_full-desc');
        if (hideContent && btnTxt) {
            cover.classList.add('s_category__desc--closed');
            hideContent.style.display = 'none';
            addMultipleListeners(btnTxt, ['click', 'touch'], () => {
                showHide(cover, hideContent);
            });
        }
    }
});
function showHide(cover, hideContent) {
    const isClosed = cover.classList.contains('s_category__desc--closed');
    cover.classList.toggle('s_category__desc--closed', !isClosed);
    hideContent.style.display = isClosed ? 'block' : 'none';
}
